// Speculative Decoding Color Scheme
// Scientific visualization palette with warm/cool semantic distinction

// === MODEL PAIR (Complementary: Navy vs Amber) ===
// Target: Cool navy = slow, authoritative, "ground truth"
// Draft: Warm amber = fast, speculative, "educated guess"
export const TARGET_MODEL = 0x2a4a6d; // Deep navy (H≈210)
export const DRAFT_MODEL = 0xb8864a;  // Warm amber (H≈35) - distinct hue

// === DATA PAIR (Teal/Green family, H≈155-180) ===
// Input: teal, Output: green-teal (shows transformation)
export const INPUT = 0x6b9ea0;        // Muted teal (H≈182)
export const INPUT_TEXT = 0x4a7072;   // Darker teal for readability

export const OUTPUT = 0x5aaa8f;       // Green-teal (H≈155) - "generated"
export const OUTPUT_TEXT = 0x3d7560;  // Darker green for readability

// === DISTRIBUTION ANALYSIS ===
export const MIN_REGION = 0x14b8a6;  // Teal - common ground between draft/target

// === VALIDATION ===
export const VALID = 0x3fb87a;       // Soft sage-green - correct prediction
export const INVALID = 0xdc5858;     // Soft coral - incorrect prediction

// === SUPPORTING ===
export const LINE = 0x6b7280;
export const LINE_ACTIVE = 0x4b5563;
export const SURFACE = 0xffffff;
export const SURFACE_ALT = 0xf8f9fa;
export const TEXT = 0x212529;

// Hex string versions for CSS
export const hex = {
  targetModel: '#2a4a6d',
  draftModel: '#b8864a',
  input: '#6b9ea0',
  inputText: '#4a7072',
  output: '#5aaa8f',
  outputText: '#3d7560',
  minRegion: '#14b8a6',
  line: '#6b7280',
  lineActive: '#4b5563',
  surface: '#ffffff',
  surfaceAlt: '#f8f9fa',
  text: '#212529',
} as const;
